var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 34.52 34.52",
    id: "cross",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.51,23.44a1.46,1.46,0,0,1-1-.43L17.26,19.8,14.05,23A1.48,1.48,0,0,1,12,23l-.45-.45a1.47,1.47,0,0,1,0-2.09l3.21-3.21-3.21-3.21a1.47,1.47,0,0,1,0-2.09l.45-.45a1.48,1.48,0,0,1,2.09,0l3.21,3.21,3.21-3.21a1.48,1.48,0,0,1,2.09,0L23,12a1.47,1.47,0,0,1,0,2.09l-3.2,3.21L23,20.47a1.47,1.47,0,0,1,0,2.09l-.44.45A1.47,1.47,0,0,1,21.51,23.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.26,34.52A17.26,17.26,0,1,1,34.52,17.26,17.28,17.28,0,0,1,17.26,34.52Zm0-31.07A13.81,13.81,0,1,0,31.07,17.26,13.83,13.83,0,0,0,17.26,3.45Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.d67cbde112a5de373d1575794c5a3b56.svg";
export { ForwardRef as ReactComponent };